/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';

const SearchAutocomplete = ({
  label = 'Buscar',
  placeholder = '',
  options = [],
  value = null,
  loading = false,
  inputValue = '',
  disabled = false,
  allowSearch = true,
  minSearchLength = 3,
  noOptionsText = 'Sin opciones',
  loadingText = 'Buscando...',
  getOptionLabel,
  onInputChange,
  onSearch,
  onChange,
  onClear,
}) => {

  const handleSearch = () => {
    if (!allowSearch)
      return;
    if (!onSearch)
      return;
    if (inputValue.trim().length < minSearchLength)
      return;
    onSearch(inputValue);
  };

  const handleClear = () => {
    if (!allowSearch)
    return;

    if (onInputChange)
        onInputChange("");
    if (onChange)
        onChange(null);
    if (onClear)
        onClear();
};

  return (

    <Autocomplete
      options={options}
      value={value}
      inputValue={inputValue}
      loading={loading}
      fullWidth
      size="small"
      disabled={disabled}
      disableClearable={!allowSearch}
      filterOptions={(x) => x}
      noOptionsText={noOptionsText}
      loadingText={loadingText}
      getOptionLabel={(option) => {
        if (!option)
          return '';
        if (getOptionLabel)
          return getOptionLabel(option);
        return option.label || '';
      }}
      onInputChange={(event, value, reason) => {
        if (reason === "clear") {
          handleClear();
          return;
        }

        // Solo impedir que escriba
        if (!allowSearch && reason === "input") {
            return;
        }

        if (onInputChange) {
            onInputChange(value);
        }      
      }}
      onChange={(event, value, reason) => {
        if (reason === "clear") {
          // if (!allowSearch)
          //   return;

          handleClear();
          return;
        }
        if (onChange)
          onChange(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={allowSearch ? placeholder : ''}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            readOnly: !allowSearch,
          }}
          onKeyDown={(e) => {
            if (!allowSearch)
              return;
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearch();
            }
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && (
                  <CircularProgress
                    color="inherit"
                    size={20}
                  />
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

SearchAutocomplete.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.object,
  loading: PropTypes.bool,
  inputValue: PropTypes.string,
  disabled: PropTypes.bool,
  allowSearch: PropTypes.bool,
  minSearchLength: PropTypes.number,
  noOptionsText: PropTypes.string,
  loadingText: PropTypes.string,
  getOptionLabel: PropTypes.func,
  onInputChange: PropTypes.func,
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
};

export default SearchAutocomplete;